export const countFilters = ({ amenities = [], priceRange = {}, sizeRange = {}, ...others } = {}) =>
  Object.keys(others).filter((key) => key !== 'strictSearch' && !!others[key]).length +
  amenities.length +
  (Object.keys(priceRange).length ? 1 : 0) +
  (Object.keys(sizeRange).length ? 1 : 0);
